module.exports = "/_next/static/images/d83c37a9dc3aef7743c753bbf8ffb0e2-credit-card-autonomy@1x.png.webp";